<script>
import {mapActions, mapGetters} from 'vuex';
import {VOD_RAILS} from '@/store/getterTypes';
import CarouselComponent from '@/components/base-components/CarouselComponent.vue';
import VodGridItem from '@/league/components/vod/VodGridItem.vue';
import {GET_VOD_RAILS} from '@/store/actionTypes';

export default {
  name: 'VodRail',
  components: {VodGridItem, CarouselComponent},
  computed: {
    ...mapGetters({
      rails: VOD_RAILS,
    }),
  },
  methods: {
    ...mapActions({
      getRails: GET_VOD_RAILS,
    }),
  },
  mounted() {
    this.getRails();
  },
};
</script>

<template>
<div class="w-100" v-if="rails.length">
  <carousel-component
    v-for="rail in rails"
    :key="rail.id"
    :min-item-width="rail.minCardWidth"
    :max-item-width="rail.maxCardWidth"
    :item-data="rail.items"
    :max-per-line="rail.items.length"
    :scrolled-quantity="1"
    :autoscroll-delay="rail.scrollTime"
    class="d-flex flex-column gap-1"
  >
    <template #before>
      <div class="w-100 d-flex justify-content-between flex-grow-1 align-items-center mr-3
          carousel-title"
      >
        <h3>{{ rail.title }}</h3>
      </div>
    </template>
    <template #default="{props}">
      <div :key="props.id" class="p-2">
        <vod-grid-item :vod-info="props" :style="{height: '100%'}" class="rail_item"/>
      </div>
    </template>
  </carousel-component>
</div>
</template>

<style lang="scss" scoped>
div {
  .rail_item {
    --vod-subtitle-color: var(--settings-body-text-color-70);
    --vod-title-color: var(--settings-body-text-color);
  }
}
</style>
